import { getThroughAuthProxy } from "../utils";

export const getImageUrlFromS3Key = (
  s3Key: string,
): Promise<{
  presignedUrl: string;
}> => {
  const urlParams = new URLSearchParams({ s3Key }).toString();
  return getThroughAuthProxy(`resolve-image?${urlParams}`);
};
